import { DropdownItemModel } from '@shared/components/dropdown/model/dropdown-item.model';

export const ITEMS_SORT_OPTIONS: DropdownItemModel[] = [
  {
    label: 'Default',
    id: '',
  },
  {
    label: 'Rarity',
    id: 'rarity',
  },
  {
    label: 'Level',
    id: 'augmentationLevel',
  },
  {
    label: 'Mana cost',
    id: 'meta.manaCost',
  },
  {
    label: 'Gear Score',
    id: 'score',
  },
];
